import dayjs from 'dayjs';
import { Duration } from 'dayjs/plugin/duration.js';
import { TimeZoneRegion } from './serializable/time-zone-region.js';
import { DataModel } from './dto/dto.js';
import { CustomerProfile } from './serializable/customer-profile.js';
import { ContactDetails } from './serializable/contact-details.js';
import { DayOfYear } from './serializable/day-of-year.js';
import { BusinessModuleRef } from './serializable/business-module-ref.js';
import { ICopyWithBusinessRef } from '../contracts/copy-with-business-ref.js';
import { TimeOfDay } from './serializable/time-of-day.js';

export interface IReservationWithClient {
  client: CustomerProfile;
  clientId: string;
}

export interface IReservationWithDate {
  dayId: string;
  monthId: string;
  dayOfYear: DayOfYear;
  timeOfDay: TimeOfDay;
  duration: Duration;
  date: dayjs.Dayjs;
  time: dayjs.Dayjs;
}

export interface IReservationWithGroup {
  groupId: string | null;
}

export interface IReviewableReservation {
  hasBeenReviewed: boolean;
}

export interface IReservationWithContactDetails {
  contactDetails: ContactDetails;
}

export abstract class Reservation extends DataModel implements ICopyWithBusinessRef {
  abstract get uniqueId(): string;
  abstract get creatorId(): string;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get timezone(): TimeZoneRegion;
  abstract get businessRef(): BusinessModuleRef;
  abstract get cancelledDate(): dayjs.Dayjs | null;
  abstract get cancelledBy(): string | null;

  abstract get time(): dayjs.Dayjs;
  abstract get duration(): Duration;

  abstract get isOpen(): boolean;
  abstract get isCanceled(): boolean;
  abstract get isUpcoming(): boolean;
  abstract get isInProgress(): boolean;
  abstract get isFinished(): boolean;

  get isOpenAndUpcoming(): boolean {
    return this.isUpcoming && this.isOpen;
  }

  abstract copyWithBusinessRef(businessRef: BusinessModuleRef): this;
}
